import React, { useEffect } from 'react';
import debounce from 'lodash/debounce';
import WeeklyAverage from '@reuters-graphics/chart-module-weeklyaverage';

const avgCasesChart = new WeeklyAverage();

const CasesTrend = (props) => {
  const { content, cases, locale, dateRange } = props;

  const casesChartContainer = React.createRef();
  const resize = debounce(() => {
    avgCasesChart.draw();
  }, 250);
  useEffect(() => {
    avgCasesChart
      .selection(casesChartContainer.current)
      .data(cases)
      .props({
        locale,
        stroke: 'rgba(255, 255, 255, 0.25)',
        strokeWidth: 2,
        height: 100,
        x_axis: false,
        bars: false,
        variable_name: 'cases',
        date_range: dateRange,
        labels: false,
        margin: { // Default values
          top: 10,
          right: 18,
          bottom: 0,
          left: 18,
        },
        chart_formats: {
          date: locale !== 'ja' ? '%b %e' : '%B %e日',
        },
      })
      .draw();
  }, [casesChartContainer, cases, locale, dateRange]);

  // Resize chart
  useEffect(() => {
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, [resize]);

  return (
    <div className='trend-container'>
      <div className='key'>{content.key}</div>
      <div className='weekly-average-chart-container' ref={casesChartContainer} />
    </div>
  );
};

export default CasesTrend;
